/**
 * @generated SignedSource<<6a17d02fcdc308888027ab33a60098fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type partnerTemplateCardCarouselRelayFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly templateId: string;
      readonly urlSlug: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"partnerTemplateCardRelayFragment">;
    };
  }>;
  readonly " $fragmentType": "partnerTemplateCardCarouselRelayFragment";
};
export type partnerTemplateCardCarouselRelayFragment$key = {
  readonly " $data"?: partnerTemplateCardCarouselRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"partnerTemplateCardCarouselRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "partnerTemplateCardCarouselRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateResultEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentPlatformTemplate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlSlug",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "partnerTemplateCardRelayFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplateContentSearchConnection",
  "abstractKey": null
};

(node as any).hash = "1c7e3f5a4cc2391a481ac057c9b64369";

export default node;
